import React from 'react';

export const component = props => (
  <svg
    style={{ width: '100%' }}
    aria-label={props.label}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 248 248.9"
  >
    <path
      fill={props.color}
      d="M0 50.2l7.4-1C36.2 45.2 64 37.8 90 24.4a141.6 141.6 0 0 0 28.7-19l5.6-5-.3-.4.5.4c8.8 9.2 19.3 16 30.3 22.1A224.2 224.2 0 0 0 208.2 43a290.3 290.3 0 0 0 34.4 6.5l5.4.8-.7 6a336 336 0 0 1-16.3 67 274 274 0 0 1-26.7 56 191 191 0 0 1-38.8 45 155.5 155.5 0 0 1-40.2 24.4 3.4 3.4 0 0 1-3-.1 160 160 0 0 1-44.2-29.6 211.5 211.5 0 0 1-38.6-49.6A318.2 318.2 0 0 1 10 98a336 336 0 0 1-8.8-39.3C.7 55.9.4 53 0 50.2zm6.5 5l.7 4.6a335.5 335.5 0 0 0 10.3 44 297.7 297.7 0 0 0 31 70c10.6 17 23 32.4 38.3 45.6a152 152 0 0 0 36.4 23.5 2 2 0 0 0 1.5 0 150.6 150.6 0 0 0 42.6-27.5 191.4 191.4 0 0 0 33.5-41 275.7 275.7 0 0 0 26.6-57.6 345.4 345.4 0 0 0 13.5-54.2l1-7-.8-.2c-6.7-1.1-13.4-2-20.1-3.4a256 256 0 0 1-50-15A174 174 0 0 1 131.8 15L124 8.4s-.2 0-.3.2a127.3 127.3 0 0 1-21.7 16c-16.6 9.9-34.4 16.9-52.9 22a290.2 290.2 0 0 1-37.3 7.8z"
    />
    <path
      fill={props.color}
      d="M26.2 69.5A269.6 269.6 0 0 0 60.5 61a225.3 225.3 0 0 0 58.4-27.2l4.9-3.2a.9.9 0 0 1 1.2 0c14 10.1 29.2 17.9 45.3 24.1A290.4 290.4 0 0 0 220 69.2l1 .1 1 .2-1.3 6.8a313.4 313.4 0 0 1-16.6 54.8 221.1 221.1 0 0 1-25.8 46.8 150.1 150.1 0 0 1-40.8 39.1c-3.8 2.4-7.8 4.4-11.6 6.7a2.5 2.5 0 0 1-3 0A153.7 153.7 0 0 1 74 181a231 231 0 0 1-29.8-53 329.9 329.9 0 0 1-17-55l-1-3.4zM215.4 74l-1.2-.3q-14.3-3-28.2-7.4c-21.8-6.9-42.4-16.2-61.3-29.1-.6-.4-1-.2-1.4 0-5.7 3.6-11.2 7.3-17.1 10.5a259.5 259.5 0 0 1-67 24.6l-6 1.3v1A316.2 316.2 0 0 0 49 125a222 222 0 0 0 33.4 57.6 147.8 147.8 0 0 0 41 35.1 1.8 1.8 0 0 0 2 0 135.9 135.9 0 0 0 38.2-30.8c12-13.7 21.5-29 29.3-45.4a295.6 295.6 0 0 0 20.8-59.8l1.7-7.8z"
    />
    <path
      fill={props.color}
      d="M184.6 91.8l-61.3 65.6-50.6-45.5 50.6 19 61.3-39z"
    />
  </svg>
);

export default component;



// WEBPACK FOOTER //
// ./src/components/UI/Img/ServiceSVG/certificateSVG.jsx